import React, { useState } from 'react';
import {
  Fab,
  Tooltip,
  Zoom,
  Box,
  Typography,
  IconButton,
  Paper,
  Divider,
} from '@mui/material';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useTranslation } from 'react-i18next';

const ContactBubble = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState({ email: false, phone: false });

  // Thông tin liên hệ - bạn có thể thay đổi
  const email = 'info@unisysvn.com.vn';
  const phone = '+84 28 3743 7768';

  const handleCopy = (text, type) => {
    navigator.clipboard.writeText(text);
    setCopied((prev) => ({ ...prev, [type]: true }));
    setTimeout(() => setCopied((prev) => ({ ...prev, [type]: false })), 2000);
  };

  return (
    <>
      {/* Bong bóng nổi */}
      <Zoom in={true} timeout={600}>
        <Fab
          color="primary"
          aria-label="contact"
          onClick={() => setOpen(!open)}
          sx={{
            position: 'fixed',
            bottom: 100,
            right: 24,
            zIndex: 1300,
            boxShadow: 3,
            '&:hover': {
              transform: 'scale(1.1)',
            },
            transition: 'all 0.3s ease',
          }}
        >
          <ContactPhoneIcon />
        </Fab>
      </Zoom>

      {/* Menu liên hệ khi mở */}
      <Zoom in={open} timeout={300}>
        <Paper
          elevation={6}
          sx={{
            position: 'fixed',
            bottom: 166,
            right: 24,
            width: 280,
            p: 2,
            borderRadius: 3,
            bgcolor: 'background.paper',
            zIndex: 1290,
            display: open ? 'block' : 'none',
          }}
        >
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            {t('contact.quick_contact') || 'Liên hệ nhanh'}
          </Typography>
          <Divider sx={{ my: 1 }} />

          {/* Email */}
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={1.5}>
            <Box display="flex" alignItems="center" gap={1}>
              <EmailIcon color="secondary" fontSize="small" />
              <Typography variant="body2" noWrap>{email}</Typography>
            </Box>
            <Tooltip title={copied.email ? t('copied') : t('copy') || 'Sao chép'}>
              <IconButton
                size="small"
                onClick={() => handleCopy(email, 'email')}
                color={copied.email ? 'success' : 'default'}
              >
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>

          {/* Phone */}
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Box display="flex" alignItems="center" gap={1}>
              <PhoneIcon color="primary" fontSize="small" />
              <Typography variant="body2">{phone}</Typography>
            </Box>
            <Tooltip title={copied.phone ? t('copied') : t('copy') || 'Sao chép'}>
              <IconButton
                size="small"
                onClick={() => handleCopy(phone, 'phone')}
                color={copied.phone ? 'success' : 'default'}
              >
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>

          <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: 'block' }}>
            {t('contact.support') || 'Hỗ trợ 24/7'}
          </Typography>
        </Paper>
      </Zoom>
    </>
  );
};

export default ContactBubble;